/**
 * Contact configuration + the mailto: fallback for the inquiry form.
 *
 * The inquiry form (src/components/sections/Inquiry.tsx, used on /availability) POSTs
 * in-page to Formspree (FORM_ENDPOINT) so the visitor stays on the site. buildMailto is
 * the fallback shown only if that request fails, so an inquiry can still reach us by email.
 * Both FORM_ENDPOINT and CONTACT_EMAIL are public, env-overridable settings inlined by Vite
 * at build time — not secrets. See Workflow/lessons.md §002.
 */

export interface InquiryPayload {
  name: string;
  email: string;
  guests: number | string;
  date: string;
  duration: string;
  type: string;
  message: string;
}

/** The charter contact email — drives the Email card (copy.ts) AND the mailto fallback below. */
export const CONTACT_EMAIL: string = (import.meta.env.VITE_CONTACT_EMAIL ?? 'giorgio.l@virtussrl.it') as string;

/** Formspree endpoint the inquiry form POSTs to. Public; set VITE_FORM_ENDPOINT to change it. */
export const FORM_ENDPOINT: string = (import.meta.env.VITE_FORM_ENDPOINT ?? 'https://formspree.io/f/mredvwve') as string;

function formatBody(p: InquiryPayload): string {
  const lines = [
    `Name:     ${p.name || '—'}`,
    `Email:    ${p.email || '—'}`,
    `Guests:   ${p.guests || '—'}`,
    `Date:     ${p.date || '—'}`,
    `Duration: ${p.duration || '—'}`,
    `Type:     ${p.type || '—'}`,
    '',
    p.message || '(no message)',
  ];
  return lines.join('\n');
}

export function buildMailto(p: InquiryPayload): string {
  const subject = `Charter inquiry — ${p.name || 'unnamed'}`;
  return (
    `mailto:${CONTACT_EMAIL}` +
    `?subject=${encodeURIComponent(subject)}` +
    `&body=${encodeURIComponent(formatBody(p))}`
  );
}
